const ScreenSize = {
    Desktop: 'desktop',
    Mobile: 'mobile',
    Tablet: 'tablet'
};
export default ScreenSize;